import { defineComponent as p, openBlock as o, createElementBlock as e, mergeProps as u, unref as l, renderSlot as g, createElementVNode as r, createCommentVNode as m } from "vue";
import { useScalarIcon as v } from "../hooks/useScalarIcon.js";
const f = { key: 0 }, k = { key: 1 }, M = { key: 2 }, Z = { key: 3 }, w = { key: 4 }, _ = { key: 5 }, h = {
  name: "ScalarIconCellSignalNone"
}, C = /* @__PURE__ */ p({
  ...h,
  props: {
    label: {},
    weight: {}
  },
  setup(s) {
    const a = s, { bind: d, weight: n } = v(a);
    return (i, t) => (o(), e("svg", u({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      fill: "currentColor"
    }, l(d)), [
      g(i.$slots, "default"),
      l(n) === "bold" ? (o(), e("g", f, t[0] || (t[0] = [
        r("path", { d: "M52,192v8a12,12,0,0,1-24,0v-8a12,12,0,0,1,24,0Z" }, null, -1)
      ]))) : l(n) === "duotone" ? (o(), e("g", k, t[1] || (t[1] = [
        r("path", { d: "M198.12,25.23a16,16,0,0,0-17.43,3.47l-160,160A16,16,0,0,0,32,216H192a16,16,0,0,0,16-16V40A16,16,0,0,0,198.12,25.23ZM192,200H32L192,40Z" }, null, -1)
      ]))) : l(n) === "fill" ? (o(), e("g", M, t[2] || (t[2] = [
        r("path", { d: "M198.12,25.23a16,16,0,0,0-17.44,3.46l-160,160A16,16,0,0,0,32,216H192a16,16,0,0,0,16-16V40A15.94,15.94,0,0,0,198.12,25.23ZM192,200H32L192,40Z" }, null, -1)
      ]))) : l(n) === "light" ? (o(), e("g", Z, t[3] || (t[3] = [
        r("path", { d: "M46,192v8a6,6,0,0,1-12,0v-8a6,6,0,0,1,12,0Z" }, null, -1)
      ]))) : l(n) === "regular" ? (o(), e("g", w, t[4] || (t[4] = [
        r("path", { d: "M48,192v8a8,8,0,0,1-16,0v-8a8,8,0,0,1,16,0Z" }, null, -1)
      ]))) : l(n) === "thin" ? (o(), e("g", _, t[5] || (t[5] = [
        r("path", { d: "M44,192v8a4,4,0,0,1-8,0v-8a4,4,0,0,1,8,0Z" }, null, -1)
      ]))) : m("", !0)
    ], 16));
  }
});
export {
  C as default
};
